import Api from '@/services/api';

export default {
  
  get(object, id) {
    return Api().get('/client/documents/' + object + '/' + id);
  },
  get_single(object, id, params = false) {
    let str = '/client/document/' + id + '/' + object;
    if(params) {
      str += "?" + params;
    }
    return Api().get(str);
  },
  add(object, id, file) {
    return Api().post('/client/documents/' + object + '/' + id, file);
  },
  userinfo(path) {
    return Api().get(path);
  }
}